import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../../services/user.service';
import {MatDialog} from '@angular/material';
import {NoteDetailsComponent} from '../../../../components/atoms/note-details/note-details.component';

@Component({
  selector: 'notes',
  templateUrl: './notes.component.html'
})

export class NotesComponent implements OnInit {
  @Input() id: number;

  orders: Array<any>;
  userId: any;
  notes: any;
  displayedColumns = ['edit', 'content', 'created_at', 'updated_at'];
  progress = true;

  length: number;
  pageIndex = 1;
  pageSize = 50;
  pageSizeOptions: number[] = [ 5, 10, 25, 50];

  constructor(private userService: UserService, public dialog: MatDialog) {}

  ngOnInit() {
    this.userService.userId.subscribe(id => {
      this.userId = id;
      this.getUserNotes(this.pageIndex, this.pageSize);
    });
  }

  getUserNotes(pageIndex: number, pageSize: number) {
    this.progress = true;
    this.userService.getUserNotes(this.userId, pageIndex, pageSize).subscribe(notes => {
      this.notes = notes;
      this.progress = false;
      this.length = notes.total;
    });
  }

  deleteUserNote(noteId) {
    this.progress = true;
    this.userService.deleteUserNote(this.userId, noteId).subscribe(data =>  {
      this.getUserNotes(this.pageIndex, this.pageSize);
      this.progress = false;
    });
  }

  addUserNote(content) {
    this.progress = true;
    this.userService.addUserNote(this.userId, {content})
      .subscribe(data => {
        this.getUserNotes(this.pageIndex, this.pageSize);
        this.progress = false;
      });
  }

  openAddDialog() {
    const dialog = this.dialog.open(NoteDetailsComponent, {width: '450px'});
    dialog.afterClosed().subscribe(data => {
      if (data.content) {
        this.addUserNote(data.content);
      }
    });
  }

  editUserNote(content, noteId) {
    this.progress = false;
    this.userService.editUserNote(this.userId, noteId, {content})
      .subscribe(data => {
        this.getUserNotes(this.pageIndex, this.pageSize);
        this.progress = true;
      });
  }

  openEditDialog(element) {
    const dialog = this.dialog.open(NoteDetailsComponent, {width: '450px', data: element.content});
    dialog.afterClosed().subscribe(data => {
      if (data.delete) {
        this.deleteUserNote(element.id);
      } else if (data.close) {
        return;
      } else {

        this.editUserNote(data.content, element.id);
      }
    });
  }

  handlePagination({pageIndex, pageSize}) {
    this.pageIndex = pageIndex + 1;
    this.pageSize = pageSize;
    this.getUserNotes(this.pageIndex, this.pageSize);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/notes/notes.component.ts